var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.56,5.74c-.32-.32-.78-.5-1.24-.47-.44,.02-.87,.22-1.19,.54l-1.45,1.45h0l-.55,.55c-.71,.71-1.13,1.64-1.19,2.6l-.02,.33c-.03,.59-.3,1.18-.75,1.62l-2.73,2.72c-1.49,1.49-1.59,3.82-.23,5.19,.64,.64,1.5,.96,2.39,.96,.99,0,2.01-.4,2.8-1.19l2.72-2.72c.44-.44,1.04-.72,1.62-.75l.33-.02c.96-.05,1.89-.47,2.6-1.19l2-2c.35-.34,.54-.81,.54-1.29,0-.44-.17-.85-.47-1.15l-5.2-5.2Zm.44,9.32l-.33,.02c-.96,.05-1.89,.47-2.6,1.19l-2.72,2.73c-.91,.91-2.28,1.01-3.07,.23-.78-.78-.68-2.16,.23-3.07l2.73-2.72c.71-.71,1.13-1.64,1.19-2.6l.02-.33c.03-.59,.3-1.18,.75-1.62l.02-.02,5.44,5.44-.02,.02c-.44,.44-1.03,.72-1.62,.75Zm3.62-2.75l-.92,.92-5.44-5.44,.92-.92c.06-.06,.14-.1,.21-.1h.01s.06,0,.09,.03l5.23,5.29c0,.08-.04,.16-.1,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,14.14l-1.45,1.45c-.29,.29-.29,.77,0,1.06,.15,.15,.34,.22,.53,.22s.38-.07,.53-.22l1.45-1.45c.29-.29,.29-.77,0-1.06s-.77-.29-1.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88,7.63c.19,0,.38-.07,.53-.22l1.41-1.41c.29-.29,.29-.77,0-1.06s-.77-.29-1.06,0l-1.41,1.41c-.29,.29-.29,.77,0,1.06,.15,.15,.34,.22,.53,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,8.25h-2c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75h2c.41,0,.75-.34,.75-.75s-.34-.75-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,5.75c.41,0,.75-.34,.75-.75V3c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v2c0,.41,.34,.75,.75,.75Z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorch);
export default __webpack_public_path__ + "static/media/torch.d59d350da348004d4cb85bf9a4f6d81f.svg";
export { ForwardRef as ReactComponent };